<form [formGroup]="loginConfirmForm" (ngSubmit)="onSubmit()">
    <div class="modal-header">
        <h4 class="modal-title">
            Confirmar usuario
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <fieldset class="form-group">
            <label for="username">Usuario</label>
            <label *ngIf="loginConfirmForm.get('username')?.hasError('required')" class="red-text h5 ml-1 mb-0">
                *
            </label>
            <input type="text" formControlName="username" placeholder="Nombre de usuario" class="form-control">
        </fieldset>
        <fieldset class="form-group">
            <label for="password">Contraseña</label>
            <label *ngIf="loginConfirmForm.get('password')?.hasError('required')" class="red-text h5 ml-1 mb-0">
                *
            </label>
            <input type="password" formControlName="password" placeholder="Contraseña" class="form-control">
        </fieldset>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-success"
            [disabled]="loginConfirmForm.invalid || loginConfirmForm.pristine">Confirmar</button>
    </div>
</form>